import React, {useRef} from 'react'
import useResizeObserver from 'use-resize-observer'

interface ResizeObserverProps {
  children: React.ReactElement
  callback: () => void
  type?: 'w' | 'h' | 'default'
  className?: string
}

export const ResizeObserver = ({
  type = 'default',
  className,
  children,
  callback
}: ResizeObserverProps) => {
  const currentWidth = useRef<number>(0)
  const currentHeight = useRef<number>(0)

  const {ref} = useResizeObserver({
    onResize: ({width, height}) => {
      if (!callback) {
        return
      }

      const widthChanged = width !== currentWidth.current
      const heightChanged = height !== currentHeight.current

      if (
        type === 'default' ||
        (type === 'w' && widthChanged) ||
        (type === 'h' && heightChanged)
      ) {
        callback()
        if (widthChanged && width) {
          currentWidth.current = width
        }
        if (heightChanged && height) {
          currentHeight.current = height
        }
      }
    }
  })

  return (
    <div className={className} ref={ref}>
      {children}
    </div>
  )
}

export const WithResizeObserver = React.memo(ResizeObserver)
